import * as React from "react"
import {Typography, Box, Badge} from "@mui/material"
import { formatPrice } from "@ui-seeker/utils"

import { useUserApp} from "@hooks";
import { BadgeVariant } from "@components"


export default function priceColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { currency, numVariants, stock }) => <PriceCell
				value={value}
				currency={currency}
				numVariants={numVariants}
				name={name}
				stock={stock}
			/>
		}
	}
}

const PriceCell = ({ value, currency, numVariants, name, stock }) => {
	const { userGroupByProductID } = useUserApp()
	return <Box sx={{display: 'flex', alignItems: 'center'}}>
		<Typography variant="body2">
			{formatPrice(value, currency)}
		</Typography>
		{!userGroupByProductID && name === 'listPrice' && stock && <BadgeVariant numVariants={numVariants} />}
	</Box>
}